module.exports = __webpack_public_path__ + "static/page-header-do-2-90cb68334b118896ee4fedffde7f7dea.png";